<template src="./index.html"></template>
<script>
import data from './data.js';
export default {
	props: {
		dialogVisible_reduce: {
			type: Boolean,
			default: false
		},
		zktotal: {
			type: Number,
			default: 0
		},
		zkhang: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			form_money: {
				DiscountRate: '', //折扣率
				DiscountMoney: '' //折扣金额
			}
		};
	},
	watch: {
		dialogVisible_reduce: function(indexVal, oldVal) {
			if (indexVal) {
				this.form_money = {
					DiscountRate: '', //折扣率
					DiscountMoney: '' //折扣金额
				};
			}
		}
	},
	created() {},
	mounted() {
		
	},
	methods: {
		closedialogVisible_reduce() {
			this.$emit('closedialogVisible_reduce', false);
		},
		/* 改变折扣金额 */
		changemoney(e) {
			this.form_money.DiscountMoney =((e / 100) * this.zktotal).toFixed(2);
		},
		/* 改变折扣行 */
		changelv(e) {
			this.form_money.DiscountRate = (e / this.zktotal) * 100;
		},
		// 折扣行保存
		forsave() {
			if (this.emptyandnull(this.form_money.DiscountMoney)) {
				this.$message.error('折扣金额不能为空');
				return false;
			}
			
			this.$emit('forsave', this.form_money);
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
